type ModEnterEvent = Pick<
  KeyboardEvent,
  'ctrlKey' | 'metaKey' | 'key' | 'preventDefault' | 'stopPropagation'
>;

export const isModEnter = (
  event: Pick<KeyboardEvent, 'ctrlKey' | 'metaKey' | 'key'>
): boolean => (event.ctrlKey || event.metaKey) && event.key === 'Enter';

export const consumeModEnterShortcut = (event: ModEnterEvent): boolean => {
  if (!isModEnter(event)) return false;
  event.preventDefault();
  event.stopPropagation();
  return true;
};
